module.exports = __webpack_public_path__ + "img/7.896b7f8.png";